/* eslint-disable */
const {
  VUE_APP_HOB: urlServicio,
  VUE_APP_HOB_USUARIO: usuarioServicio,
  VUE_APP_HOB_CONTRASENA: contrasenaServicio,
} = process.env;

class WebServiceHub {
  constructor() {
    this._usuario = usuarioServicio;
    this._contrasena = contrasenaServicio;
    this._clientId = 1021;
  }

  get token() {
    const datosAutenticacion = {
      Username: this._usuario,
      Password: this._contrasena,
      ClientId: this._clientId,
    };

    const body = JSON.stringify({
      ...datosAutenticacion,
    });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body,
    };

    return fetch(`${urlServicio}gettoken`, requestOptions)
      .then((response) => response.json())
      .then((result) => result)
      .catch((error) => console.log("error", error));
  }

  async consultarVehiculo(placa) {
    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${await this.token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await fetch(
        `${urlServicio}vehiculo/${placa}`,
        requestOptions
      );
      return await response.json();
    } catch (error) {
      console.error(error);
    }
  }
}

export default WebServiceHub;
